import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors, ValidatorFn, FormControl } from '@angular/forms';

@Directive({
    selector: '[appAutocompleteValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: AutocompleteValidationDirective, multi: true }],
    standalone: false
})
export class AutocompleteValidationDirective implements Validator {

    validate(control: AbstractControl): ValidationErrors {
        return this.validateCostType(control);
    }

    private validateCostType: ValidatorFn = (control: FormControl): ValidationErrors | null => {
        if ((control.value instanceof Object)) {
            return null;
        }
        return { 'notMatch': true };
    }
}

